import { createContext } from 'react';

export const SurveyViewContext = createContext<{ isEditInputOnly: boolean } | undefined>(undefined);
